import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import { GetAllHostedQuizs } from "../../api/Quiz/GetAllHostedQuizs";
import Spinner from "../../components/Shared/Spinner";
import TrashIcon from "../../components/Icons/TrashIcon";
import DeleteModal from "../../components/Shared/DeleteModal";
import { DeleteMCQ } from "../../api/Quiz/DeleteQuiz";
import AddHostedQuiz from "./AddHostedQuiz";
import QRCode from "react-qr-code";
import { HostedQuizsDTO } from "../../api/Quiz/GetAllHostedQuizs";
import { Link } from "react-router-dom";
import { Copy } from "lucide-react";
const HostQuizs = () => {
  const [showAddCourse, setShowAddCourse] = useState(false);
  const [isMCQOpen, setIsMCQOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const { data: QuizsResponse, isLoading: isBlogsLoading } = useQuery({
    queryFn: GetAllHostedQuizs,
    queryKey: ["hosted"],
    staleTime: 0,
    refetchInterval: 0,
  });

  const quizs = QuizsResponse?.data || [];

  const downloadQR = (qrCode: string, name: string) => {
    const svgElement = document.getElementById(`qr-code-${qrCode}`);
    if (svgElement) {
      const svgData = new XMLSerializer().serializeToString(svgElement);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (ctx) {
        const img = new Image();
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const pngFile = canvas.toDataURL("image/png");

          const downloadLink = document.createElement("a");
          downloadLink.download = `QRCode-${name}.png`;
          downloadLink.href = `${pngFile}`;
          downloadLink.click();
        };
        img.src = "data:image/svg+xml;base64," + btoa(svgData);
      } else {
        console.error("Failed to get drawing context for the canvas");
      }
    } else {
      console.error("SVG element not found for QR code");
    }
  };

  const handleAddCourseSuccess = () => {
    setShowAddCourse(false);
  };

  const handleDeleteMCQ = async (id: string) => {
    await DeleteMCQ(id);
    toast.success("MCQ Quiz deleted successfully");
  };

  const copyQuizUrl = (qrCode: string) => {
    const url = `${window.location.origin}/hosted-quiz/${qrCode}`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success("Quiz URL copied to clipboard!");
      })
      .catch((err) => {
        toast.error("Failed to copy URL");
        console.error("Failed to copy:", err);
      });
  };

  if (isBlogsLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div>
      {showAddCourse ? (
        <AddHostedQuiz onSuccess={handleAddCourseSuccess} />
      ) : (
        <div className="pb-10">
          <div className="flex justify-between items-center py-7">
            <h1 className="text-burntBlack font-bold text-[32px]">
              All Hosted Quizs
            </h1>
            <Button
              onClick={() => setShowAddCourse(true)}
              className="!h-12 w-48 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
              variant="primary"
            >
              <AddIcon className="mr-1.5" />
              Host a new Quiz
            </Button>
          </div>
          <div className="grid grid-cols-3 gap-6">
            {quizs &&
              quizs.map((mcq: HostedQuizsDTO, index: number) => (
                <div
                  key={mcq.id}
                  className="flex border border-black/15 rounded-lg flex-col justify-between items-center py-4  relative"
                >
                  <h1 className="text-center">
                    MCQ {index + 1}. {mcq.title}
                  </h1>
                  <span className="font-bold mb-4 mt-2">
                    QR Code: {mcq.qrCode}
                  </span>
                  <QRCode
                    id={`qr-code-${mcq.qrCode}`}
                    size={200}
                    value={
                      `${window.location.origin}/hosted-quiz/${mcq.qrCode}` ||
                      "00000"
                    }
                    level="H"
                  />
                  <button
                    onClick={() => copyQuizUrl(mcq.qrCode)}
                    className="p-2 bg-gray-100 border-secondary border rounded-full mx-auto w-fit mt-3"
                    title="Copy quiz URL"
                  >
                    <Copy className="text-secondary" />
                  </button>
                  <Link to={`/dashboard/host-quizs/scores/${mcq.id}`}>
                    <Button
                      className=" w-48 !text-sm font-bold !h-11 mt-4 !bg-[#4379EE] hover:!bg-primary"
                      variant="primary"
                    >
                      Student Scores
                    </Button>
                  </Link>
                  <Button
                    className="before:!bg-primary hover:text-white !text-base !font-bold !h-11 my-4 w-48 !border-primary !border-2 text-primary"
                    variant="transparent"
                    onClick={() => downloadQR(mcq.qrCode, mcq.title)}
                  >
                    Download QR Code
                  </Button>

                  <button
                    onClick={() => {
                      setSelectedId(mcq.id);
                      setIsMCQOpen(true);
                    }}
                    className="bg-red-500 text-white px-4 py-2 rounded flex items-center gap-2 duration-300 transition-all hover:bg-red-900"
                  >
                    Delete <TrashIcon />
                  </button>
                  <DeleteModal
                    isOpen={isMCQOpen}
                    setIsOpen={setIsMCQOpen}
                    mutationFn={() => handleDeleteMCQ(selectedId!)}
                    itemId={selectedId!}
                    queryKey="hosted"
                  />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HostQuizs;
